import React, { Component } from 'react';
import './../css/master.css';
import './../css/availability.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
var httpURL = '';
var queryString = require('querystring');
var lstAvailability =[];
var lstMonthSpan=[];
var machineIdCol 		= 'td:eq(0)';
var machineTypeCol 		= 'td:eq(1)';
var machineCapacityCol 	= 'td:eq(2)';
var machineCountCol 	= 'td:eq(3)';
var mId='';

class Availability extends Component {
  constructor(props){
	super(props);
	this.state={
		availability:[],
		lstAvailability:[],
		minDate:new Date(),
		maxDate:null,
		machineId:'',
		endDate:null,
		startDate:null,
    }
	this.handleChange = this.handleChange.bind(this);
	this.handleChange1 = this.handleChange1.bind(this);
  }
  
  handleChange(date){
    this.setState({
      startDate: date,
    });
  }
  handleChange1(date){
    this.setState({
      endDate: date
    });
  }
  
  
  async componentDidMount(){
	 var date =  new Date();
	 date.setMonth(date.getMonth()+1);
   
	 var endDate = new Date(date);
	 endDate.setDate( endDate.getDate()+89);
	await this.setState({
		startDate:new Date(date),
		endDate:new Date(endDate),
	})
	 
	const height = $('#typeTable thead').height();
	$('#availabilityTable thead').css('height',height+' !important');
	this.getAvailability();
 }
  
 getAvailability =()=> {
	var fromDate = $('#inp_fromDate').val();
	var toDate = $('#inp_toDate').val();
	var weaverId = sessionStorage.getItem('weaverId');
	
	axiosInstance.post(httpURL+'/w/ipo/availability/list', 
		queryString.stringify({'weaverId':weaverId,'startDt':fromDate,'endDt':toDate}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
				lstAvailability=response.data.lstAvailability;
				lstMonthSpan=response.data.lstMonthSpan;
				this.setAvailabilityTable();
		}
		else{
			toast.error(response.data.SvcMsg)
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
	}).catch((e)=>{
		toast.error("Service failed "+e);
	});
}

setAvailabilityTable =()=> {
	$('#availabilityTableBody tr').remove();
	$('#availabilityTable thead tr').remove();
	var row3 = document.createElement('tr');
	var row2 = document.createElement('tr');
 	for(var z=0; z<lstMonthSpan.length; z++){
		var month = lstMonthSpan[z].month;
		var span = lstMonthSpan[z].spanCols;
    var maxD =lstMonthSpan.spanCols;
	  this.addTH2(row3,lstMonthSpan[z].spanCols+lstMonthSpan[z].startDay-1,lstMonthSpan[z].startDay);
		this.addTH(row2, span, month);
	}
	
	$('#availabilityTable thead').append(row2);
	$('#availabilityTable thead').append(row3);
	$('#typeTableBody tr').remove();
	var typeTable 			= document.getElementById('typeTable');
	var typeTbody 			= document.getElementById('typeTableBody');
	var availabilityTable 	= document.getElementById('availabilityTable');
	var availabilityTbody 	= document.getElementById('availabilityTableBody');
		
	for(var i=0; i<lstAvailability.length; i++){
		var machineTypeId	= lstAvailability[i].mtyId;
		var machineType		= lstAvailability[i].mty;
		var capacity   		= lstAvailability[i].capacity;
		var count 			= lstAvailability[i].count;
		var availability	= lstAvailability[i].availability;
		
		var row = document.createElement('tr');
			row.id = machineTypeId;
	
		var row1 = document.createElement('tr');
		
		for(var j=0; j<availability.length; j++){
			this.addTD1(row1, availability[j], count, '');
			availabilityTbody.append(row1);
		}
	
		this.addTD(row, machineType, '');
		this.addTD(row, capacity, 'txtright');
		this.addTD(row, count, 'txtright');
		
		typeTbody.append(row);
		availabilityTable.append(availabilityTbody);
	}
	typeTable.append(typeTbody);
}
	
		
addTD(row, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var text = document.createTextNode(val);
	cell.append(text);
	row.append(cell);
	$('#buyerPOAddForm').show().siblings().hide();
}

addTD1(row, val, count, classname){
	var cell = document.createElement('td');
	if(val == count){
		cell.style.backgroundColor = 'rgb(223, 253, 172)';
	    cell.className += classname;
	    cell.colSpan=2;
	    row.append(cell);
	$('#buyerPOAddForm').show().siblings().hide();
	}else if(val == 0){
		cell.style.backgroundColor = '#ddd';
		cell.className += classname;
     	cell.colSpan=2;
    	var icon = document.createElement('span');
	    icon.className="glyphicon glyphicon-remove text-muted";
	    cell.append(icon);
       	row.append(cell);
	$('#buyerPOAddForm').show().siblings().hide();
	}else{
	      cell.style.backgroundColor = '#fff';
		  cell.className += classname;
	      cell.colSpan=2;
		     var text = document.createTextNode(val);
		     cell.append(text);
		     row.append(cell);
		$('#buyerPOAddForm').show().siblings().hide();
		
		}
	 }
	addTH(row, span, val){
		var cell = document.createElement('th');
		cell.style.textAlign='center';
		cell.colSpan = span*2;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	addTH2(row, maxdate,startdate){
	
		for(var m=startdate;m<=maxdate; m++){
			var cell = document.createElement('th');
			cell.style.width='20px';
			var text = document.createTextNode(m);
			cell.colSpan = 2;
			cell.append(m);
			row.append(cell)
		
		}
		}

  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<WeaverHeader />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div className="main">
				<div className="container-fluid">
					<div className="col-sm-12 col-centered">
						<div className="col-sm-6 col-centered"  style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', marginBottom:10}}>
							<div style={{flex:1}} className="text-center">
								<label htmlFor="inp_fromDate">From Date</label>
							</div>
							<div style={{flex:2}} className="text-center">
								<DatePicker id="inp_fromDate"
									className='form-control text-center'
									placeholderText="From Date"
									selected={this.state.startDate}
									onChange={this.handleChange}
									dateFormat="dd-MM-yyyy"
									minDate= {this.state.minDate}
									autoComplete='off'
								/>
							</div>
							<div style={{flex:1}} className="text-center">
								<label htmlFor="inp_toDate">To Date</label>
							</div>
							<div style={{flex:2}} className="text-center">
								<DatePicker id="inp_toDate"
									className='form-control text-center'
									placeholderText="To Date"
									selected={this.state.endDate}
									onChange={this.handleChange1}
									dateFormat="dd-MM-yyyy"
									minDate= {this.state.startDate}
									maxDate= {this.state.maxDate}
									autoComplete='off'
								/>
							</div>
							<div className="pull-right">
							
								<button style={{marginRight:20,marginLeft:20}} type="button" className="btn btn-warning" onClick={this.getAvailability} id="availability">Availability</button>
									</div>
						</div>
						<div className="row">
							<div style ={{width:'25%'}} className="availabilityTableDiv1 col-sm-3 col-xs-3 padding-remove">
								<table id="typeTable" className="tableLayout">
									<thead>
										<tr>
											<th style={{width:50,display:'none'}}>Machine Id</th>
											<th style={{width:120,height:44}}>Machine Type</th>
											<th style={{width:40}}>Capacity</th>
											<th style={{width:30}}>Count</th>
										</tr>
									</thead>
									<tbody id="typeTableBody">
									</tbody>
								</table>
							</div>
							<div className="availabilityTableDiv col-sm-9 col-xs-9 padding-remove" style={{width:'75%'}}>
								<table id="availabilityTable" className="">
									<thead>
										<tr>
											<th style={{width:200, textAlign:'center'}}>Availability</th>
										</tr>
									</thead>
									<tbody id="availabilityTableBody">
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Availability;
